if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();

      this.parent = this.closest("product-page");
    }

    /**
     * @description Called when the element is added to the DOM
     */
    connectedCallback() {
      this.querySelectorAll("select, input").forEach((element) => {
        element.addEventListener("change", (event) => {
          this.parent.variant_options_changed();
        });
      });
    }
  }

  customElements.define("variant-picker", VariantPicker);
}
